/*[01/30/22, PC_EF_09, Priyanka.D]*/
import React, { Component } from 'react';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
//
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { MapInteractionCSS } from 'react-map-interaction';
import swal from 'sweetalert';
import EnersysPDFComponent from './EnersysFormPDFComponent'

class EnersysyFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            /*[01/30/22, PC_EF_10, Priyanka.D]*/
            storenumdisabled: localStorage.getItem("StoreValue") != null ? true : false,
            storenum: localStorage.getItem("StoreValue") != null ? localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1) : "W",
            /*[01/30/22, PC_EF_14, Priyanka.D]*/
            Plant: "", Month: "", Year: "",
            PlantDD: [
                { label: "C", value: "C" },
                { label: "R", value: "R" },
                { label: "M", value: "M" },], MonthDD: "", YearDD: "", serialnumtext: "",
            attachmentPathArr: [],
            EnersysList: this.props.location.state.pagename == "shoppingcart" ? this.props.location.state.EnersysList : [] //WW-920_PC_07 -Aparna
        }
        this.keyPress = this.keyPress.bind(this);
        this.UpdateItemDesp_response = this.UpdateItemDesp_response.bind(this)
        this.DeleteItemFromCart_response = this.DeleteItemFromCart_response.bind(this)
    }
    componentDidMount() {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //  let test = this.props.location.state.item;
        // console.log("test", test);
        $('#firstdigit').removeClass(' css-1okebmr-indicatorSeparator');
        /*[01/30/22, PC_EF_14, Priyanka.D]*/
        this.BindSerialId()
        /*[02/02/22, PC_EF_30, Priyanka.D]*/
        NonCatalogStore.on('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.on("Status", this.AddtocartSuccess);
        ItemDetailNewStore.on("addToCart", this.AddToCartResponse);
        //WW-920_PC_07 -Aparna
        ShoppingCartStore.on("UpdateStatus", this.UpdateItemDesp_response);
        ShoppingCartStore.on("deleteItem", this.DeleteItemFromCart_response);
    }
    componentWillUnmount() {
        NonCatalogStore.removeListener('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.removeListener("Status", this.AddtocartSuccess);
        ItemDetailNewStore.removeListener("addToCart", this.AddToCartResponse);
        //WW-920_PC_08 -Aparna
        ShoppingCartStore.removeListener("UpdateStatus", this.UpdateItemDesp_response);
        ShoppingCartStore.removeListener("deleteItem", this.DeleteItemFromCart_response);
    }
    /***
     * WW-920_PC_11 -Aparna
     * to insert file path in cart table
     * */
    ItemInCart = () => {
        let UpdateItemDetails = {
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            fldToUpdate: "FILE_PATH",
            ItemID: this.state.EnersysList[0].SupplierPartNumber,
            LineNum: this.state.EnersysList[0].LineItem,
            newValue: this.state.attachmentPathArr[0].FilePath
        }
        ShoppingCartAction.UpdateItemDesp(UpdateItemDetails);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /**
     * WW-920_PC_13 -Aparna
     * response method after inserting file path in cart and to get next form detail or to navigate  to shoppingcart
     * */
    UpdateItemDesp_response = () => {
        $('#ItemDetail').modal('hide');
        let locEnersysFormList = this.state.EnersysList.splice(1);
        if (locEnersysFormList.length > 0) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.setState({
                storenumdisabled: localStorage.getItem("StoreValue") != null ? true : false,
                storenum: localStorage.getItem("StoreValue") != null ? localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1) : "W",
                Plant: "", Month: "", Year: "",
                PlantDD: [
                    { label: "C", value: "C" },
                    { label: "R", value: "R" },
                    { label: "M", value: "M" },], MonthDD: "", YearDD: "", serialnumtext: "",
                attachmentPathArr: [],
                EnersysList: locEnersysFormList
            })
            this.BindSerialId()
        }
        else if (this.props.location.state.FormList.length > 0) {
            this.props.history.push({
                pathname: "/forms",
                state: { pagename: "shoppingcart", FormName: this.props.location.state.FormList[0].FormName, FormList: this.props.location.state.FormList, EnersysList: [] }
            });
        }
        else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    }
    /**
     * WW-920_PC_14 -Aparna
     * to delete item from cart
     * */
    DeleteItemFromCart = () => {
        let DeleteItemBO = {
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            ItemID: this.state.EnersysList[0].SupplierPartNumber,
            LineNum: this.state.EnersysList[0].LineItem,
            DeleteFlag: true
        };
        ShoppingCartAction.DeleteCartItem(DeleteItemBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /**
     * WW-920_PC_15 -Aparna
     * delete response method and to get next form detial or to navigate to shoppingcart
     * */
    DeleteItemFromCart_response = () => {
        let deleteItemAry = JSON.parse(ShoppingCartStore.deleteItemAry);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (deleteItemAry != "" || deleteItemAry != null) {
            let locEnersysFormList = this.state.EnersysList.splice(1);
            //  this.setState({ EnersysList: locEnersysFormList })
            if (locEnersysFormList.length > 0) {
                this.setState({
                    storenumdisabled: localStorage.getItem("StoreValue") != null ? true : false,
                    storenum: localStorage.getItem("StoreValue") != null ? localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1) : "W",
                    Plant: "", Month: "", Year: "",
                    PlantDD: [
                        { label: "C", value: "C" },
                        { label: "R", value: "R" },
                        { label: "M", value: "M" },], MonthDD: "", YearDD: "", serialnumtext: "",
                    attachmentPathArr: [],
                    EnersysList: locEnersysFormList
                })
                this.BindSerialId()
            }
            else if (this.props.location.state.FormList.length > 0) {
                // console.error("formlist", this.props.location.state.FormList[0].FormAttribute)
                this.props.history.push({
                    pathname: "/forms",
                    state: { pagename: "shoppingcart", FormName: this.props.location.state.FormList[0].FormName, FormList: this.props.location.state.FormList, EnersysList: [] }
                });
            }
            else {
                this.props.history.push({
                    pathname: "/shoppingcart",
                });
            }
        }
        else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    }
    AddToCartResponse = () => {
        let AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#ItemDetail').modal('hide');
        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            this.props.history.push({
                //pathname: "/shoppingcart",
                pathname: `\shoppingcart`
            });
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Techincal Issue Contact SDI Customer Care"
            });
            // alert("Techincal Issue Contact SDI Customer Care");
        }
    }
    /*[02/02/22, PC_EF_33, Priyanka.D]*/
    AddtocartSuccess = () => {
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        
        let Status = JSON.parse(SearchResultsStore.SuccessStatus);
        $('#ItemDetail').modal('hide');
        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {

                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                    });
                    // alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }

                //window.location.reload();
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');

                this.props.history.push({
                    //pathname: "/shoppingcart",
                    pathname: `\shoppingcart`,
                    search: `?SearchKey=${this.props.location.state.searchKey}`
                });

            }
            else {

                let itemidnotinserted = ""
                let validate = false
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                    });
                    //  alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }
                if (validate == true) {

                    //window.location.reload();




                    this.props.history.push({
                        //pathname: "/shoppingcart",
                        pathname: `\shoppingcart`,
                        search: `?SearchKey=${this.props.location.state.searchKey}`
                    });


                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Techincal Issue Contact SDI Customer Care"
                    });
                    //  alert("Techincal Issue Contact SDI Customer Care")
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }
    /*[02/02/22, PC_EF_31, Priyanka.D]*/
    loadAttachments = () => {
        
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            console.log("attachmentResponse", attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            //WW-920_PC_12 -Aparna
            if (this.props.location.state.pagename != "shoppingcart") {
                this.AddToCart();
            } else {
                this.ItemInCart()
            }

        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    onAccordianClick = (event, index) => {
        
        if (index == 0) {
            let Refcss = document.getElementById("arrow-0").className
            if (Refcss == "accordion-arrow") {
                $('#arrow-0').addClass('accordion-arrow-change');
            } else {
                $('#arrow-0').removeClass('accordion-arrow-change');
            }
            let refimg = document.getElementById("refImg").className
            if (refimg == "p d-none content-row hiddenRow" || refimg == "p content-row hiddenRow d-none") {
                $('#refImg').removeClass('d-none');
            } else {
                $('#refImg').addClass('d-none');
            }
        } else if (index == 1) {
            let Refcss = document.getElementById("arrow-1").className
            if (Refcss == "accordion-arrow") {
                $('#arrow-1').addClass('accordion-arrow-change');
            } else {
                $('#arrow-1').removeClass('accordion-arrow-change');
            }
            let refimg = document.getElementById("expImg").className
            if (refimg == "p d-none content-row hiddenRow" || refimg == "p content-row hiddenRow d-none") {
                $('#expImg').removeClass('d-none');
            } else {
                $('#expImg').addClass('d-none');
            }
        }

    };
    /*[01/30/22, PC_EF_13, Priyanka.D]*/
    handleChangeStoreNum = (values) => {
        if (isNaN(Number.parseInt(values.target.value.substring(values.target.value.length - 1, values.target.value.length)))) {
            if (values.target.value.length == 1) {
                this.setState(
                    { storenum: 'W' })
            } else {
                this.setState(
                    { storenum: 'W' + values.target.value.substring(1, values.target.value.length - 1) })
            }
        } else {
            this.setState(
                { storenum: 'W' + values.target.value.substring(1, values.target.value.length) })
        }
    }
    /*[01/30/22, PC_EF_14, Priyanka.D]*/
    BindSerialId = () => {
        
        let YearDD = [];
        let MonthDD = [];
        let i = 0;
        let j = 0;
        let num = "";
        let mnth = 0;
        let yr = 2006;
        let s = '', t;
        let locyrarray = {};
        for (i = 5; i < 27; i++) {
            t = (i - 1) % 26;
            s = String.fromCharCode(65 + t);
            num = (i - t) / 26 | 0;
            if (s != "O" && s != "Q") {
                locyrarray = {
                    label: s,
                    value: yr
                }
                yr++
                YearDD.push(locyrarray);
            }
        }
        console.log("YearDD", YearDD)
        this.setState({ YearDD: YearDD });
        let Month = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        for (j = 1; j < 13; j++) {
            t = (j - 1) % 26;
            s = String.fromCharCode(65 + t);
            num = (j - t) / 26 | 0;
            let locmntharray = {
                label: s,
                value: j
            }
            MonthDD.push(locmntharray);
        }
        console.log("MonthDD", MonthDD)
        this.setState({ MonthDD: MonthDD });
    }
    /*[02/01/22, PC_EF_16, Priyanka.D]*/
    handlePlantDD = (e) => {
        this.state.PlantDD.filter((item, index) => item.label == e.label && item.value == e.value);
        let Plant = this.state.PlantDD.filter((item, index) => item.label == e.label && item.value == e.value);
        this.setState({ Plant: Plant })
    }
    /*[02/01/22, PC_EF_17, Priyanka.D]*/
    handleYearDD = (e) => {
        let Year = this.state.YearDD.filter((item, index) => item.label == e.label && item.value == e.value);
        this.setState({ Year: Year })
    }
    /*[02/01/22, PC_EF_18, Priyanka.D]*/
    handleMonthDD = (e) => {
        let Month = this.state.MonthDD.filter((item, index) => item.label == e.label && item.value == e.value);
        this.setState({ Month: Month })
    }
    /*[02/01/22, PC_EF_20, Priyanka.D]*/
    Submit = () => {
        /*[04/26/22,PC_A1QA-168_07], Priyanka D */
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        let EnersysItem = "";
        let ItemID = "";
        //WW-920_PC_09 -Aparna
        if (this.props.location.state.pagename == "shoppingcart") {
            CartStorage.forEach((val) => {
                if (val.FilePath != null && val.FilePath.includes('Enersys')) {
                    EnersysItem = EnersysItem.concat(val.Itemid);
                }
            });
        }
        if (this.props.location.state.pagename.indexOf('SearchResult') > -1) {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        } else if (this.props.location.state.pagename == "shoppingcart") {
            ItemID = ""
        }
        else {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        }
        if (EnersysItem.indexOf(ItemID) > -1 && this.props.location.state.pagename != "shoppingcart") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "This Enersys Item is already added in the cart. Please go to cart to increase quantity !"
            });
            //  alert("This Enersys Item is already added in the cart. Please go to cart to increase quantity !")
            return
        } else {
            if (this.state.Plant[0] != undefined && this.state.Month[0] != undefined && this.state.Year[0] != undefined && this.state.serialnumtext.length > 5) {
                
                let today = new Date();
                let ToMonth = (today.getMonth()) + 1;
                let ToYear = (today.getFullYear());
                let FromYear = this.state.Year[0].value;
                let FromMonth = this.state.Month[0].value;
                let yearAge = ToYear - FromYear;
                let MonthAge = 0
                if (ToMonth > FromMonth) {
                    MonthAge = ToMonth - FromMonth;
                } else {
                    yearAge--;
                    MonthAge = 12 + ToMonth - FromMonth;
                }
                if (FromYear > ToYear) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Second digit is Invalid. Please see the Reference sheet"
                    });
                    //  alert("Second digit is Invalid. Please see the Reference sheet");
                    return;
                } else if ((FromYear == ToYear) && (FromMonth > ToMonth)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Third digit is Invalid. Please see the Reference sheet"
                    });
                    // alert("Third digit is Invalid. Please see the Reference sheet");
                    return;
                } else if (yearAge < 3) {
                    $('#ItemDetail').modal('show');
                } else {
                    $('#BateryNotAvailable').modal('show');
                }
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter the valid serial number!"
                });
                // alert("Please enter the valid serial number!");
                return;
            }
        }

    }
    //[1/5/23, PC_WW-552_FE_30, Dhevanesam R]
    keyPress(e) {
        const invalidChars = ["-", "+", "e",];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };
    handleserialtextchange = (values) => {
        
        if (values.target.value.length == 1 || values.target.value.length < 7) {
            this.setState(
                { serialnumtext: values.target.value })
        } else {
            this.setState(
                { serialnumtext: values.target.value.substring(0, 6) })
        }
    }
    /*[02/02/22, PC_EF_23, Priyanka.D]*/
    BateryNotAvailableClick = () => {
        $('#BateryNotAvailable').modal('hide');
    }
    /*[02/02/22, PC_EF_32, Priyanka.D]*/
    AddToCart() {
        
        console.log('pagename', this.props.location.state.pagename);
        let quantity = this.props.location.state.qty;
        if (this.props.location.state.pagename == 'ItemDetail') {
            if (this.props.location.state.item.NonItemDetails[0] != undefined) {
                this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
                
            }
            SearchResultsAction.AddCart(this.props.location.state.item)
        }
        else if (this.props.location.state.pagename == 'SearchResult') {
            if (this.props.location.state.item.NonItemDetails[0] != undefined) {
                this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
                
            }

            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please complete the form"
            });
            // alert("Please complete the form");
        }
    }
    /*[02/02/22, PC_EF_27, Priyanka.D]*/
    //[1/11/23, WW-552, Dhevanesam R]
    handleAttachment = (b) => {
        var b = new File([b], 'Enersys - Form.pdf');
        let files = [];
        files.push(b);
        if (this.props.location.state.pagename != "shoppingcart") {
            if (files.length > 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item Successfully Added To Cart"
                });
            }
        }
        //  alert("Item Successfully Added To Cart")
        NonCatalogAction.FormsaddAttachment(files);

    }

    render() {
        return (

            <div className="container-fluid content-margin cctop">
                <div className="row">
                    <div className="col-md-12 page-heading my-3">
                        {/**WW-920_PC_10 -Aparna**/}
                        {this.props.location.state.pagename != "shoppingcart" ?
                            this.props.location.state.product.trim().indexOf('BATTERY') > -1 ?
                                <h5 id="heading" className="page-title">Enerys Battery Form</h5> :
                                <h5 id="heading" className="page-title"><Trans>Enerys Charger Form</Trans></h5>
                            : this.state.EnersysList[0].product.indexOf('BATTERY') > -1 ?
                                <h5 id="heading" className="page-title">Enerys Battery Form</h5> :
                                <h5 id="heading" className="page-title"><Trans>Enerys Charger Form</Trans></h5>}
                    </div>
                    {this.props.location.state.pagename == "shoppingcart" ?
                        <div className="col-md-12 mb-4">
                            <label id="Itemid_head" className="float-left col-md-2 form-label catalog-label">Item ID </label>
                            <label id="Itemid_head2" >{this.state.EnersysList[0].SupplierPartNumber}</label>
                        </div> : null}
                    <div className="col-md-12 mb-4">
                        <label className="float-left col-md-2 form-label catalog-label">Store Number</label>
                        <input type="text" className="form-control col-md-4 " maxLength="5" name="Quantityvalue" id="Storenum"
                            value={this.state.storenum} onChange={e => this.handleChangeStoreNum(e)} /*[01/30/22, PC_EF_11, Priyanka.D]*/
                            disabled={this.state.storenumdisabled}
                        />
                    </div>
                    <label className="float-left col-md-2 form-label catalog-label" style={{ "marginLeft": "15px", "margin-right": "-7px" }}>Serial Number</label>
                    <Select className="SerialNum" style={{ "fontSize": "14px" }} onChange={e => this.handlePlantDD(e)} components={{ IndicatorSeparator: () => null }} value={this.state.Plant} placeholder=" " options={this.state.PlantDD} >{/*[02/01/22, PC_EF_15, Priyanka.D]*/}

                    </Select>
                    <Select className="SerialNum" style={{ "fontSize": "14px" }} onChange={e => this.handleYearDD(e)} components={{ IndicatorSeparator: () => null }} value={this.state.Year} placeholder=" " options={this.state.YearDD}>{/*[02/01/22, PC_EF_18, Priyanka.D]*/}

                    </Select>
                    <Select className="SerialNum" style={{ "fontSize": "14px" }} onChange={e => this.handleMonthDD(e)} components={{ IndicatorSeparator: () => null }} value={this.state.Month} placeholder=" " options={this.state.MonthDD}>{/*[02/01/22, PC_EF_17, Priyanka.D]*/}

                    </Select>
                    {/*1/6/23,PC_WW-552_FE_31, Dhevanesam R*/}
                    <input type="number" value={this.state.serialnumtext} className="form-control col-md-2 " min="0" max="6" name="Quantityvalue" onChange={e => this.handleserialtextchange(e)} id="SerialNumberText" style={{ "height": "38px" }} onKeyDown={e => this.keyPress(e)}

                    />
                    <div className="col-md-12" style={{ "borderBottom": "1px solid #e4e3e3", "marginTop": "16px" }}>
                        {this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.product.trim().indexOf('CHARGER') > -1 ?
                            <span id="notes" className="form-label col-md-10 mb-4 catalog-label">PLEASE NOTE:  REPLACEMENT POWER CORD IS ZEUS CATALOG ITEM # 828981 - PURCHASE SEPARATELY </span>
                            : <span id="notes" className="form-label col-md-10 mb-4 catalog-label">PLEASE NOTE:   BOTH BATTERY PART # 0795-7700 MUST BE REPLACED AT THE SAME TIME (FORCED QTY OF 2)</span> :
                            this.state.EnersysList[0].product.trim().indexOf('CHARGER') > -1 ?
                                <span id="notes" className="form-label col-md-10 mb-4 catalog-label">PLEASE NOTE:  REPLACEMENT POWER CORD IS ZEUS CATALOG ITEM # 828981 - PURCHASE SEPARATELY </span>
                                : <span id="notes" className="form-label col-md-10 mb-4 catalog-label">PLEASE NOTE:   BOTH BATTERY PART # 0795-7700 MUST BE REPLACED AT THE SAME TIME (FORCED QTY OF 2)</span>}

                    </div>
                    <div className="col-md-12">
                        <button className="btn btn-primary custom-btn-primary primary-btn px-3 mt-4 ml-3 float-right" onClick={e => this.Submit()}>{this.props.location.state.pagename != "shoppingcart" ? "Add to Cart" : "Update Cart"}</button>{/*[02/01/22, PC_EF_19, Priyanka.D]*/}
                        {this.props.location.state.pagename == "shoppingcart" ?
                            <button className="btn  grid-btn-decline   px-3 mt-4 ml-3 float-right"
                                onClick={() => this.DeleteItemFromCart()}

                            >Delete Item</button> : null}
                    </div>
                    <div className="col-md-12 mb-4 mt-3">
                        <span className="accordion-toggle" id="ref" onClick={(e) => this.onAccordianClick(e, 0)}>
                            <div>

                                <span className="float-left form-label col-md-4 mb-4  mt-0 catalog-label" style={{ "marginLeft": "43px", "fontWeight": "bold" }}>Reference Sheet </span>
                                <span className="accordion-arrow" style={{ "marginLeft": "17px" }} id="arrow-0">

                                </span>
                            </div>
                        </span>
                    </div>
                    <div id="refImg" className="p d-none content-row hiddenRow" style={{ "marginLeft": "419px" }}>
                        <div className="py-1" id="order-row-0">
                            <React.Fragment>
                                <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                    <img title="Reference" src="images/Reference.png" alt="Reference" />
                                </MapInteractionCSS>
                            </React.Fragment>
                        </div>
                    </div>
                    <div className="col-md-12 mb-4">
                        <span className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, 1)}>
                            <div>
                                <span className="float-left form-label col-md-4 mb-4  mt-0 catalog-label" style={{ "marginLeft": "43px", "fontWeight": "bold" }}>See example serial number on battery</span>
                                <span className="accordion-arrow" style={{ "marginLeft": "17px" }} id="arrow-1">
                                </span>
                            </div>
                        </span>
                    </div>
                    <div id="expImg" className="p d-none content-row hiddenRow" style={{ "marginLeft": "419px" }}>
                        <div className="py-1" id="order-row-0">
                            <React.Fragment>
                                <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                    <img title="Reference" src="images/ExampleImgForm.png" alt="Reference" />
                                </MapInteractionCSS>
                            </React.Fragment>
                        </div>
                    </div>

                </div>
                <div className="modal" id="ItemDetail" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content" style={{ "marginLeft": "78px", "height": "246px" }}>
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}
                            <div className="text-center">
                                <label>Store Number<span> : </span>{this.state.storenum}</label>
                            </div>
                            {this.state.Plant[0] != undefined && this.state.Year[0] != undefined && this.state.Month[0] != undefined && this.state.serialnumtext != undefined ?
                                <div className="text-center">
                                    <label>Serial Number<span> : </span>{this.state.Plant[0].value + this.state.Year[0].label + this.state.Month[0].label + this.state.serialnumtext}</label>
                                </div> : null}

                            {this.props.location.state.pagename == "shoppingcart" ?
                                <div className="text-center">
                                    <label>Enersys Part Number<span> : </span>{this.state.EnersysList[0].SupplierPartNumber}</label>
                                </div> :
                                <div className="text-center">
                                    <label>Enersys Part Number<span> : </span>{this.props.location.state.item.NonItemDetails[0].ItemId}</label>
                                </div>}
                            <div className="text-center">
                                {this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.product.trim().indexOf('BATTERY') > -1 ?
                                    <label>Description<span> : </span>Battery Module QTY({this.props.location.state.qty})</label> :
                                    <label>Description<span> : </span>Charger module</label> :
                                    this.state.EnersysList[0].product.trim().indexOf('BATTERY') > -1 ?
                                        <label>Description<span> : </span>Battery Module QTY({this.state.EnersysList[0].qty})</label> :
                                        <label>Description<span> : </span>Charger module</label>}
                            </div>


                            {this.props.location.state.pagename != "shoppingcart" ? <div className="col-md-12 mt-4 text-center mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2"
                                    onClick={
                                        async () => {
                                            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                            const doc = <EnersysPDFComponent
                                                item={this.props.location.state.item} ItemID={this.props.location.state.pagename.indexOf('SearchResult') > -1 ? this.props.location.state.item.NonItemDetails[0].ItemId : this.props.location.state.item.NonItemDetails[0].ItemId} storenum={this.state.storenum}
                                                qty={this.props.location.state.qty} Product={document.getElementById("heading").innerText} PartDesc={this.props.location.state.product.trim().indexOf('BATTERY') > -1 ?
                                                    "Battery Module(Qty" + this.props.location.state.qty + ")" : "Charger module"} serialNum={this.state.Plant[0].value + this.state.Year[0].label + this.state.Month[0].label + this.state.serialnumtext} />;
                                            const asPdf = pdf([]);
                                            asPdf.updateContainer(doc);
                                            const blob = await asPdf.toBlob();
                                            saveAs(blob, 'Enersys - Form.pdf');
                                            this.handleAttachment(blob);
                                        }
                                    }

                                >Proceed</button>{/*[02/02/22, PC_EF_24, Priyanka.D]*/}
                            </div> :
                                <div className="col-md-12 mt-4 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2"
                                        onClick={
                                            async () => {
                                                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                                const doc = <EnersysPDFComponent
                                                    item={this.state.EnersysList[0].SupplierPartNumber} ItemID={this.state.EnersysList[0].SupplierPartNumber} storenum={this.state.storenum}
                                                    qty={this.state.EnersysList[0].qty} Product={document.getElementById("heading").innerText} PartDesc={this.state.EnersysList[0].product.trim().indexOf('BATTERY') > -1 ?
                                                        "Battery Module(Qty" + this.state.EnersysList[0].qty + ")" : "Charger module"} serialNum={this.state.Plant[0].value + this.state.Year[0].label + this.state.Month[0].label + this.state.serialnumtext} />;
                                                const asPdf = pdf([]);
                                                asPdf.updateContainer(doc);
                                                const blob = await asPdf.toBlob();
                                                saveAs(blob, 'Enersys - Form.pdf');
                                                this.handleAttachment(blob);
                                            }
                                        }

                                    >Proceed</button>{/*[02/02/22, PC_EF_24, Priyanka.D]*/}
                                </div>}

                        </div>
                    </div>
                </div>
                <div className="modal" id="BateryNotAvailable" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "434px" }}>
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}

                            <div className="text-center my-4">
                                <span className="info-label">This battery unit is more than 3 years old and requires a complete replacement. However, replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause</span>
                            </div>


                            <div className="col-md-12 text-center mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={e => this.BateryNotAvailableClick()}>Ok</button>{/*[02/02/22, PC_EF_22, Priyanka.D]*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default withTranslation()(EnersysyFormComponent);